export const translations = {
    authorsSubHeadline: `Ekipa Niesamowitych Autorów`,
    authorsHeadline: 'Topowi Twórcy E-Booków',

    authorsButtonShowMore: 'ZOBACZ WIĘCEJ',
};

export default translations;
